import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		authUserSId: null,           // 인증아이디
		userNum: null,               // 회원번호
		userId: null,                // 회원아이디
		userName: null,              // 회원명
		userProfile: null,           // 회원 프로필 이미지
		boardActiveCode: null,       // 현재 게시글 카테고리
		boardList: [],               // 현재 카테고리 리스트
		productInfo: [],
		noteAlarmCnt: 0,             // 쪽지 갯수
		noticeAlarmCnt: 0,           // 공지 갯수
		messagesList: [],            // 경고 메시지 리스트
		historyUrl: [],              // 게시글 이동 히스토리
		boardReadList: [],           // 게시글 읾음 저장
		emoticons: [],               // 이모티콘
	},
	mutations: {
		setEmoticon(state, emoticons) {
			state.emoticons = emoticons
		},
		setAuthUserSId(state, authUserSId) {
			state.authUserSId = authUserSId;
		},
		setUserNum(state, userNum) {
			state.userNum = userNum;
		},
		setUserId(state, userId) {
			state.userId = userId;
		},
		setUserName(state, userName) {
			state.userName = userName;
		},
		setUserProfile(state, userProfile) {
			state.userProfile = userProfile;
		},
		setBoardActiveCode(state, boardActiveCode) {
			state.boardActiveCode = boardActiveCode;
		},
		setBoardList(state, boardList) {
			state.boardList = boardList;
		},
		setProductInfo(state, productInfo) {
			state.productInfo = productInfo;
		},
		setNoticeAlarmCnt(state, noticeAlarmCnt) {
			state.noticeAlarmCnt = noticeAlarmCnt;
		},
		setMessagesList(state, messagesList) {
			state.messagesList = messagesList;
		},
		setHistoryUrl(state, data) {
			state.historyUrl = data;
		},
		setBoardReadList(state, seq) {
			state.boardReadList = seq;
		},
		clear(state) {
			state.authUserSId = null;
			state.userNum = null;
			state.userId = null;
			state.userName = null;
			state.userProfile = null;
			state.boardActiveCode = null;
			state.boardList = [];
			state.historyUrl = [];
			state.boardReadList = [];
			state.emoticons = []
			localStorage.clear();
		},
	},
	actions: {
		clear({commit}) {
			commit('clear');
		},
	},
	modules: {},
	plugins: [createPersistedState()],
})
